var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"realTimeChart"}},[_c('VueApexCharts',{ref:"chart",attrs:{"type":"line","height":"650","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }